import { createPinia } from "pinia";
import PrimeVue from "primevue/config";
import { createApp } from "vue";
import App from "./App.vue";
import { initPwa } from "./ts/register-sw";
import router from "./ts/routes/routers";
import { EbookPreset } from "./theme/ebook-preset";
import "./less/main.less";
import "primeicons/primeicons.css";

import Button from "primevue/button"
import Dialog from "primevue/dialog"
import Tooltip from "primevue/tooltip"


createApp(App)
        .use(createPinia())
        .use(PrimeVue, {
                ripple: false,
                theme: {
                        preset: EbookPreset,
                        options: {
                                darkModeSelector: false,
                        },
                },
        })
        .use(router)
        .component('Button', Button)
        .component('Dialog', Dialog)
        .directive("tooltip", Tooltip)
        .mount("#app")

initPwa()

//2
